/* eslint-disable linebreak-style */
import React from 'react';
import { useLocation } from "react-router-dom"
import { makeStyles } from '@material-ui/styles';
import Loader from 'react-loader-spinner'
import { connect } from 'react-redux';
import {
  colors,
  Card,
  CardHeader,
  CardContent,
  Divider,
  TextField,
  InputBase,
  Grid
} from '@material-ui/core';

import { Password, CommissionerReport, UserReport } from './components';
import { t } from '../../i18n';
import { getLocalizedText } from '../../utils/lookupLocale';


const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4),
    background: colors.blueGrey[100],
    height: '100%',
    textAlign: 'center',
    overflow: 'auto'
  },
  spinner: {
    textAlign: 'center',
    padding: '200px'
  },
  gol: {
    height: '100%',
  }
  ,
  img: {
    maxWidth: '300px',
    maxHeight: '200px',
    padding: '20px'

  }
}));

const Dashboard = (props) => {
  const { loading } = props
  const classes = useStyles();

  const location = useLocation()
  const queryParameters = new URLSearchParams(location.search)

  const codResetare = () => {
    console.log(queryParameters.get("code"))
    if (queryParameters.get("code") !== "" && queryParameters.get("code") !== null) {
      return true;
    } else {

      return false;
    }
  }


  if (loading === true) {
    return (
      <div className={classes.spinner}>
        <Loader
          color="#00BFFF"
          height={100}
          type="Puff"
          width={100}
        />
      </div>
    )
  } else {

    return (
      <div className={classes.root}>
        { // <h2 style={{paddingTop:'20px', color: colors.blueGrey[900]}}>Larexir WebStore</h2>
          // <h5 style={{paddingBottom:'20px', color: 'grey'}}>aplicatie comenzi retaileri</h5>
        }
        <div className={classes.gol}>
          <Card>
            <CardHeader
              style={{ background: colors.blueGrey[400] }}
              title={t('dashboard.generalInfo')}
            />
            <Divider />
            <CardContent style={{ overflow: 'scroll', maxHeight: '350px' }} >
              {props.informari ?
                props.informari.map((mesaj) => {
                  const mesaj1 = getLocalizedText(mesaj, 'mesaj1');
                  const mesaj2 = getLocalizedText(mesaj, 'Mesaj2');
                  const mesaj3 = getLocalizedText(mesaj, 'Mesaj3');
                  const mesaj4 = getLocalizedText(mesaj, 'Mesaj4');
                  const mesaj5 = getLocalizedText(mesaj, 'Mesaj5');
                  return (
                  <div key={mesaj.id} style={{ pading: '10px' }}>
                    <TextField
                      fullWidth
                      inputProps={{ min: 0, style: { textAlign: 'center', paddingTop: '0px', fontWeight: 'bold' } }}
                      margin="dense"
                      name="titlu"
                      size="small" // the change is here
                      value={mesaj1}
                    />
                    {mesaj2 ? <InputBase multiline fullWidth value={mesaj2} /> : null}
                    {mesaj3 ? <InputBase multiline fullWidth value={mesaj3} /> : null}
                    {mesaj4 && props.currentUser?.idFirma?.cfg2 !== 'DA' ? <InputBase multiline fullWidth value={mesaj4} /> : null}
                    {mesaj5 ?
                      <InputBase
                        fullWidth
                        inputProps={{ min: 0, style: { textAlign: 'center', paddingTop: '0px', fontWeight: 'bold', color: 'red' } }}
                        value={mesaj5}
                      /> : null}
                  </div>
                  );
                })
                : null
              }
              {props.firma && props.firma[0] ?
                null
                :
                <div>
                  <div>
                    <InputBase multiline fullWidth value={t('dashboard.welcome')} style={{ paddingTop: '0px', fontWeight: 'bold', color: '#78909C' }} />
                    <InputBase multiline fullWidth value={t('dashboard.signInInfo')} style={{ paddingTop: '0px', color: '#78909C' }} />

                    {/* <InputBase multiline fullWidth value={'Daca rulati aplicatia pe sistemul de operare WINDOWS 7 sau 8, o sa va rugam sa instalati ultimele update-uri ale acestuia.'} style={{ paddingTop:'0px',  fontWeight: 'bold', color:'#A60E0E' }}/>
                    // <InputBase multiline fullWidth value={'Browserele detecteaza daca aveti o varianta de Windows 7 sau 8 careia ii lipsesc update-uri vitale privind securitatea si vor bloca conectarea la unele aplicatii din motive de securitate.'} style={{ paddingTop:'0px', color:'#A60E0E' }}/>
              // <a href="https://www.youtube.com/watch?v=dcLViwTPvnc" style={{ textAlign: 'right', fontWeight: 'bold'}}>Link video instructiuni realizare update-uri Windows 7</a>  */}
                  </div>
                </div>
              }


            </CardContent>
          </Card>

          {props.firma && <Card style={{ marginTop: '15px' }}>
            <CardHeader
              style={{ background: colors.blueGrey[400] }}
              title={t('dashboard.companyMessages', {
                name: props.firma
                  ? (props.firma[0] ? props.firma[0].denumire.toUpperCase() : '')
                  : ''
              })}
            />
            <Divider />
            <CardContent style={{ overflow: 'scroll', maxHeight: '350px' }} >
              {props.firma ?
                <InputBase
                  fullWidth
                  inputProps={{ min: 0, style: { textAlign: 'center', paddingTop: '0px', fontWeight: 'bold', color: 'red' } }}
                  multiline
                  value={props.firma[0] ? props.firma[0].mesajpersonalizat : ''}
                />
                : null}
            </CardContent>

            <Divider />
            {codResetare() ?
            <div className={classes.root}>
              <h5 style={{ color: 'grey', textAlign:"left" }}>{t('dashboard.resetTitle')}</h5>
              <Grid
                container
                spacing={4}
              >
                <Grid
                  item
                  md={5}
                  xs={12}
                >
                  <Password codResetare={queryParameters.get("code")} />
                </Grid>
              </Grid>
            </div>
            :
            null}

          </Card>}
          {props.currentUser?.idFirma?.cfg1 === 'DA' && (
            <Card style={{ marginTop: '15px' }}>
              <CommissionerReport />
            </Card>
          )}
          {props.currentUser?.idFirma && props.currentUser?.idFirma?.cfg1 !== 'DA' && (
            <Card style={{ marginTop: '15px' }}>
              <UserReport />
            </Card>
          )}

          {
            // <div>
            // <img src="/images/dashbord/craciun.png" alt="Sarbatori fericite!"/>
            // </div> 
          }

        </div>

      </div>
    );
  }

};

const mapStateToProps = state => ({
  loading: state.order.currentProduct,
  errors: state.user.currentUser,
  warnings: state.order.currentOrder,
  currentUser: state.user.currentUser,
  firma: state.lookup.firma,
  informari: state.lookup.informari
})

export default connect(mapStateToProps)(Dashboard);
